export default "__VITE_ASSET__DTGnxsFz__"